import { FleekError } from './FleekError';

type BunnyPullZoneNotFoundErrorOptions = {
  name: string;
};

export class BunnyPullZoneNotFoundError extends FleekError<BunnyPullZoneNotFoundErrorOptions> {
  public name = 'BunnyPullZoneNotFoundError';

  toString = () => `PullZone with name ${this.data.name} was not found on BunnyCDN.`;
}
